import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import * as keyboardEventHelpers from 'globals/keyboardEvents';
import ConversationInputStyles from '../../conversation/ChatConversationInput/styles';

import messages from './messages';

class ChatFormInputEnter extends React.PureComponent {
  handleKeyPress = e => {
    const { onClick, disabled } = this.props;

    if (keyboardEventHelpers.isEnterKey(e) && !disabled) {
      e.preventDefault();
      e.stopPropagation();
      onClick();
    }
  };

  handleSubmit = () => {
    const { onClick, disabled } = this.props;

    if (!disabled) {
      onClick();
    }
  };

  render() {
    const { tabIndex, className, intl } = this.props;

    return (
      <div
        style={ConversationInputStyles.enter}
        className={className}
        onClick={this.handleSubmit}
        onKeyPress={this.handleKeyPress}
        tabIndex={tabIndex}
        role="button"
        aria-label={intl.formatMessage(messages.aria_label_send_message)}
      >
        <div style={ConversationInputStyles.enterIcon} />
      </div>
    );
  }
}

ChatFormInputEnter.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  tabIndex: PropTypes.string,
  intl: intlShape.isRequired,
};

ChatFormInputEnter.defaultProps = {
  disabled: false,
  className: null,
  tabIndex: null,
};

const componentWithIntl = injectIntl(ChatFormInputEnter);
export default componentWithIntl;
